import { render, staticRenderFns } from "./RecommendCars.vue?vue&type=template&id=adfd83a0&scoped=true&"
import script from "./RecommendCars.vue?vue&type=script&lang=js&"
export * from "./RecommendCars.vue?vue&type=script&lang=js&"
import style0 from "./RecommendCars.vue?vue&type=style&index=0&id=adfd83a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfd83a0",
  null
  
)

export default component.exports